import React, { useEffect, useState } from "react"
import { FaSpotify } from "react-icons/fa"

const fonts = [
  "Free License",
  "Valetta Man",
  "Berkshire Swash",
  "Rubik Mono One",
  "Sedgwick Ave Display",
  "Rubik Glitch",
  "Henny Penny",
  "Cinzel Decorative",
  "Nosifer",
  "Bungee Shade",
  "Creepster",
  "Monoton",
]

export default function BreathoText() {
  const [currentFont, setCurrentFont] = useState(0)
  const [isGlitching, setIsGlitching] = useState(false)

  useEffect(() => {
    const interval = setInterval(() => {
      setIsGlitching(true)
      setTimeout(() => {
        setCurrentFont((prev) => (prev + 1) % fonts.length)
        setTimeout(() => {
          setIsGlitching(false)
        }, 150)
      }, 150)
    }, 2000)

    return () => clearInterval(interval)
  }, [])

  const getRandomSize = () => {
    const baseSize = window.innerWidth < 640 ? 20 : 30
    const maxSize = window.innerWidth < 640 ? 60 : 90
    return Math.floor(Math.random() * (maxSize - baseSize + 1) + baseSize)
  }

  return (
    <div className="w-full h-full flex flex-col items-center justify-center overflow-hidden p-4">
      <style jsx>{`
        @font-face {
          font-family: "Free License";
          src: url("/fonts/free-license-font/Free License.ttf")
              format("truetype"),
            url("/fonts/free-license-font/Free License.otf") format("opentype");
          font-weight: normal;
          font-style: normal;
        }
        @font-face {
          font-family: "Valetta Man";
          src: url("/fonts/Valetta Man.otf") format("opentype");
          font-weight: normal;
          font-style: normal;
        }
        @keyframes glitch {
          0% {
            clip-path: inset(50% 0 30% 0);
            transform: translate(-5px, 5px);
          }
          20% {
            clip-path: inset(15% 0 65% 0);
            transform: translate(5px, -5px);
          }
          40% {
            clip-path: inset(40% 0 43% 0);
            transform: translate(-5px, -5px);
          }
          60% {
            clip-path: inset(80% 0 5% 0);
            transform: translate(5px, 5px);
          }
          80% {
            clip-path: inset(10% 0 85% 0);
            transform: translate(-5px, 5px);
          }
          100% {
            clip-path: inset(40% 0 43% 0);
            transform: translate(5px, -5px);
          }
        }
        .glitching {
          animation: glitch 0.3s infinite steps(2, end);
        }
        @keyframes oscillate {
          0%,
          100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-3px);
          }
        }
      `}</style>
      <div className="relative" aria-live="polite">
        <h1
          className="font-bold text-center text-white"
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            alignItems: "baseline",
            gap: "0.5rem",
            position: "relative",
            zIndex: 1,
            fontFamily: fonts[currentFont],
            textShadow: `
              0 0 7px rgba(255, 255, 255, 0.3),
              0 0 10px rgba(255, 255, 255, 0.2),
              0 0 21px rgba(255, 255, 255, 0.1),
              0 0 42px rgba(255, 255, 255, 0.05)
            `,
          }}
        >
          {"Breatho".split("").map((letter, index) => (
            <span
              key={index}
              className={isGlitching ? "glitching" : ""}
              style={{
                fontSize: `${getRandomSize()}px`,
                lineHeight: "1",
                textShadow: `
                  0 0 7px rgba(255, 255, 255, 0.3),
                  0 0 10px rgba(255, 255, 255, 0.2),
                  0 0 21px rgba(255, 255, 255, 0.1),
                  0 0 42px rgba(255, 255, 255, 0.05)
                `,
              }}
            >
              {letter}
            </span>
          ))}
        </h1>
        {isGlitching && (
          <>
            <h1
              className="font-bold text-center text-white absolute top-0 left-0 text-[#ff0000] mix-blend-multiply"
              style={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "center",
                alignItems: "baseline",
                gap: "0.5rem",
                clipPath: "inset(50% 0 30% 0)",
                transform: "translate(-5px, 2px)",
                fontFamily: fonts[currentFont],
                textShadow: `
                  0 0 7px rgba(255, 255, 255, 0.3),
                  0 0 10px rgba(255, 255, 255, 0.2),
                  0 0 21px rgba(255, 255, 255, 0.1),
                  0 0 42px rgba(255, 255, 255, 0.05)
                `,
              }}
            >
              {"Breatho".split("").map((letter, index) => (
                <span
                  key={index}
                  style={{
                    fontSize: `${getRandomSize()}px`,
                    lineHeight: "1",
                    textShadow: `
                      0 0 7px rgba(255, 255, 255, 0.3),
                      0 0 10px rgba(255, 255, 255, 0.2),
                      0 0 21px rgba(255, 255, 255, 0.1),
                      0 0 42px rgba(255, 255, 255, 0.05)
                    `,
                  }}
                >
                  {letter}
                </span>
              ))}
            </h1>
            <h1
              className="font-bold text-center text-white absolute top-0 left-0 text-[#00ff00] mix-blend-multiply"
              style={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "center",
                alignItems: "baseline",
                gap: "0.5rem",
                clipPath: "inset(30% 0 50% 0)",
                transform: "translate(5px, -2px)",
                fontFamily: fonts[currentFont],
                textShadow: `
                  0 0 7px rgba(255, 255, 255, 0.3),
                  0 0 10px rgba(255, 255, 255, 0.2),
                  0 0 21px rgba(255, 255, 255, 0.1),
                  0 0 42px rgba(255, 255, 255, 0.05)
                `,
              }}
            >
              {"Breatho".split("").map((letter, index) => (
                <span
                  key={index}
                  style={{
                    fontSize: `${getRandomSize()}px`,
                    lineHeight: "1",
                    textShadow: `
                      0 0 7px rgba(255, 255, 255, 0.3),
                      0 0 10px rgba(255, 255, 255, 0.2),
                      0 0 21px rgba(255, 255, 255, 0.1),
                      0 0 42px rgba(255, 255, 255, 0.05)
                    `,
                  }}
                >
                  {letter}
                </span>
              ))}
            </h1>
          </>
        )}
      </div>
      <a
        href="https://open.spotify.com/album/7lYS2rms6cNmUOj1NuZpMX?si=wJHN7denSr254ZWOE8pTYw&nd=1&dlsi=6bfc1f8ef35a4a01"
        target="_blank"
        rel="noopener noreferrer"
        className="mt-6 flex items-center gap-2 text-white text-base sm:text-lg font-semibold"
        style={{
          animation: "oscillate 2s infinite",
        }}
      >
        Hear me out on: <FaSpotify className="text-xl sm:text-2xl" />
      </a>
    </div>
  )
}
